import React from 'react';
import PropTypes from 'prop-types';

import ProductPropertyTab, { PropertyList } from '../../molecules/product-detail-accordion';

const MATERIAL_CARE_PROPERTIES = [
  'Care Instructions',
  'Material'
];

const Materials = (props) => {
  if (!props.product) return null;

  const materials = props.product?.product_properties?.filter(
    (property) => MATERIAL_CARE_PROPERTIES.includes(property.property_name)
  );

  if (!materials || materials.length === 0) return null;

  return (
    <ProductPropertyTab title="Material / Ingredients / Care">
      <PropertyList element="ul" like="paragraph-2">
        {
          materials.map((item) =>
            // eslint-disable-next-line react/no-danger
            <li key={item.id} dangerouslySetInnerHTML={{ __html: item.value }} />)
        }
      </PropertyList>
    </ProductPropertyTab>
  );
};

Materials.propTypes = {
  product: PropTypes.object.isRequired
};

export default Materials;
